import { Modal, ModalCloseButton } from "../ui/Modal";

interface VideoModalProps {
  open: boolean;
  onClose: () => void;
  /** URL de embed (YouTube/Vimeo) ou arquivo de vídeo (.mp4/.webm). */
  src: string;
}

const isFile = (src: string) => /\.(mp4|webm|ogg)(\?|$)/i.test(src);

export const VideoModal = ({ open, onClose, src }: VideoModalProps) => (
  <Modal open={open} onClose={onClose} variant="media" label="Vídeo do Ninja Burger">
    <div className="relative aspect-video overflow-hidden rounded-2xl border border-line bg-night">
      {open &&
        (isFile(src) ? (
          <video src={src} controls autoPlay className="size-full">
            <track kind="captions" />
          </video>
        ) : (
          <iframe
            src={src}
            title="Vídeo do Ninja Burger"
            className="size-full"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        ))}
      <ModalCloseButton onClick={onClose} className="absolute right-3 top-3" />
    </div>
  </Modal>
);
